import ImageWithFallback from "@/components/ImageWithFallback";

export const columns = () => {
  return [
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "code",
      header: "ID",
      cell: ({ row }) => <div>{row.getValue("code")}</div>,
    },
    {
      accessorKey: "label",
      header: "Label",
      cell: ({ row }) => (
        <div className="flex items-center justify-center">
          {row.getValue("label")}
        </div>
      ),
      enableResizing: false,
      enableSorting: false,
    },
  ];
};
